import { render, staticRenderFns } from "./ArticleTextTabButtonCompact.vue?vue&type=template&id=7bebfd90&"
import script from "./ArticleTextTabButtonCompact.vue?vue&type=script&lang=ts&"
export * from "./ArticleTextTabButtonCompact.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTextTabButtonCompact.vue?vue&type=style&index=0&id=7bebfd90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports